// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
'use strict';
import { PFixField } from './PFixField';
export class PFixLongArrayField extends PFixField {
    constructor(fieldId, buffer) {
        super(fieldId, buffer);
        this.Value = [];
    }
    ReadValue(buffer) {
        const len = buffer.ReadInt32();
        const array = new Array(len);
        for (let i = 0; i < len; i++) {
            array[i] = buffer.ReadInt64();
        }
        this.Value = array;
    }
    Write(buffer) {
        const array = this.Value;
        buffer.WriteShort(this.FieldId);
        buffer.WriteInt32(array.length);
        for (let i = 0, len = array.length; i < len; i++) {
            buffer.WriteInt64(array[i]);
        }
    }
}
